import React from 'react';
import classNames from 'classnames';
import { NavRoute } from 'models/NavRoutes';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './FmNavigation.styles.scss';
import './FmNavigation.styles.responsive.scss';

type FmNavigationProps = {
  className?: string;
  routes: NavRoute[];
};

const FmNavigation: React.FC<FmNavigationProps> = (props) => {
  const { routes, className } = props;
  const { t } = useTranslation();

  const classes = classNames('fm-navigation', className);

  return (
    <nav className={classes}>
      <ul>
        {routes.map(({ path, label, Icon }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={({ isActive }) => {
                if (isActive) return 'active';
              }}
            >
              {Icon && <Icon />}
              {t(label)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FmNavigation;
